import api from "../../api/api";
import API_URL from "../../api/url";


const buildParams = (param) => {
    const params = {
        page: param.page || 1,  // Default to page 1 if not provided
        limit: 10,             // Default limit
        search: param.search,
        salonName: param.salonName,
        serviceName: param.serviceName,
        visitType: param.visitType,
        salonType: param.salonType,
        type: param.type,
        status: param.status,
        appointmentStatus: param.appointmentStatus,
        limit: 10, 
    };


    // const params = {
    //     page: param.page || 1,  // Default to page 1
    //     limit: 10,
    //     search: param.search || '',
    //     salonName: param.salonName || '',
    //     serviceName: param.serviceName || '',
    //     visitType: param.visitType || '',
    //     // salonType: param.salonType || '',
   
    // };
    // Dynamically set status based on type
    if (param?.type === 4) {
        params.status = 0; // Pending
    } else if (param?.type === 5) {
        params.status = 1; // Completed
    } else if (param?.type === 6) {
        params.status = 2; // Cancelled
    }

    return params;
};

const AppoinmentRequest = {
    appoinmentList: (param) => {
        console.log("first===",param);
        const requestParams = buildParams(param); // Build dynamic params
        return api.get(`${API_URL.BASEURL}${API_URL.appointment}`, {
            params: requestParams,
        });
    },

 
    appoinmentDetails: (param) =>
        api.get(`${API_URL.BASEURL}${API_URL.appointmentDetails}`, {
            params: {
                appointmentId: param?.id,
            },
        }),
};

export default AppoinmentRequest;



// const AppoinmentRequest = {


//     appoinmentList: (param) => api.get(`${API_URL.BASEURL}${API_URL.appointment}`, {
//         params: {
//             page: param?.page,
//             appointmentStatus: param?.appointmentStatus,
//             salonName: param?.salonName,
//             visitType : param.visitType,
//             status: param?.status,
//             salonName: param?.salonName,
//             type : param?.type,
//             serviceName : param?.serviceName,
//             search: param?.search
//         };

 
//     }),
//     appoinmentDetails: (param) => api.get(`${API_URL.BASEURL}${API_URL.appointmentDetails}`, {
//         params: {
//             appointmentId: param?.id
//         }
//     }),

    

// }
// export default AppoinmentRequest